<p-dropdown
  [options]="selectItems"
  [(ngModel)]="selectedItem"
  (onChange)="selectedItemChanged($event)"
  [filter]="true"
  [style]="{ width: '100%' }"
>
</p-dropdown>
